"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconStep5 = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.031.072C5.441.072.098 5.414.098 12.005c0 6.59 5.343 11.933 11.933 11.933s11.934-5.342 11.934-11.933c0-6.59-5.343-11.933-11.934-11.933zm0 1.5c5.762 0 10.434 4.67 10.434 10.433 0 5.762-4.672 10.433-10.434 10.433S1.598 17.768 1.598 12.005c0-5.762 4.671-10.433 10.433-10.433z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.986 17c2.103 0 3.514-1.32 3.514-3.329v-.028c0-2.078-1.451-3.09-3.296-3.09-.638 0-1.059.113-1.506.281l.149-2.303h3.467a.765.765 0 000-1.531h-4.2a.745.745 0 00-.745.703l-.198 3.517c-.02.371.154.726.46.936.315.216.72.235 1.082.113.354-.12.747-.199 1.179-.199 1.153 0 1.967.632 1.967 1.63v.027c0 1.026-.746 1.7-1.886 1.7-.625 0-1.209-.226-1.766-.617-.389-.273-.934-.25-1.236.116-.267.324-.25.804.082 1.062A4.664 4.664 0 0011.986 17z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconStep5, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;